import React from 'react';
import { Admin, Resource, type ResourceOptions, LoginWithEmail } from "react-admin";
import { i18nProvider } from '../../i18nProvider';

// FG Inicio
import InicioList from './fg-inicio/InicioList';
import InicioCreate from './fg-inicio/InicioCreate';
import InicioEdit from './fg-inicio/InicioEdit';

// FG Quienes Somos
import QuienesSomosFGList from './fg-quienes-somos/QuienesSomosList';
import QuienesSomosFGCreate from './fg-quienes-somos/QuienesSomosCreate';
import QuienesSomosFGEdit from './fg-quienes-somos/QuienesSomosEdit';

// FG Publicidad
import PublicidadList from './fg-publicidad/PublicidadList';
import PublicidadCreate from './fg-publicidad/PublicidadCreate';
import PublicidadEdit from './fg-publicidad/PublicidadEdit';

// FG Archivo Patrimonial
import ArchivoPatrimonialList from './fg-archivo-patrimonial/ArchivoPatrimonialList';
import ArchivoPatrimonialCreate from './fg-archivo-patrimonial/ArchivoPatrimonialCreate';
import ArchivoPatrimonialEdit from './fg-archivo-patrimonial/ArchivoPatrimonialEdit';

// FG Edificio Corporativo
import EdificioCorporativoList from './fg-edificio-corporativo/EdificioCorporativoList';
import EdificioCorporativoCreate from './fg-edificio-corporativo/EdificioCorporativoCreate';
import EdificioCorporativoEdit from './fg-edificio-corporativo/EdificioCorporativoEdit';

// FG Pioneros Energia
import PionerosEnergiaList from './fg-pioneros-energia/PionerosEnergiaList';
import PionerosEnergiaCreate from './fg-pioneros-energia/PionerosEnergiaCreate';
import PionerosEnergiaEdit from './fg-pioneros-energia/PionerosEnergiaEdit';

// Iconos
import GroupsIcon from '@mui/icons-material/Groups';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ArchiveIcon from '@mui/icons-material/Archive';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BoltIcon from '@mui/icons-material/Bolt';

import { customDataProvider, customAuthProvider } from '../../config/services/strapi/provider';

function App() {

  return (
    <Admin
      basename='/admin'
      dataProvider={customDataProvider}
      authProvider={customAuthProvider}
      loginPage={LoginWithEmail}
      i18nProvider={i18nProvider}
    >

      <Resource
        name="fg-inicios"
        list={InicioList}
        create={InicioCreate}
        edit={InicioEdit}
        options={{
          label: 'FG Inicio',
        } as ResourceOptions}
        icon={HomeWorkIcon}
      />

      <Resource
        name="fg-quienes-somoss"
        list={QuienesSomosFGList}
        create={QuienesSomosFGCreate}
        edit={QuienesSomosFGEdit}
        options={{
          label: 'FG Quienes Somos',
        } as ResourceOptions}
        icon={GroupsIcon}
      />

      <Resource
        name="fg-edificio-corporativos"
        list={EdificioCorporativoList}
        create={EdificioCorporativoCreate}
        edit={EdificioCorporativoEdit}
        options={{
          label: 'FG Edificio Corporativo',
        } as ResourceOptions}
        icon={ApartmentIcon}
      />

      <Resource
        name="fg-archivo-patrimonials"
        list={ArchivoPatrimonialList}
        create={ArchivoPatrimonialCreate}
        edit={ArchivoPatrimonialEdit}
        options={{
          label: 'FG Archivo Patrimonial',
        } as ResourceOptions}
        icon={ArchiveIcon}
      />

      <Resource
        name="fg-publicidadess"
        list={PublicidadList}
        create={PublicidadCreate}
        edit={PublicidadEdit}
        options={{
          label: 'FG Publicidad',
        } as ResourceOptions}
        icon={NewspaperIcon}
      />

      <Resource
        name="fg-pioneros-energias"
        list={PionerosEnergiaList}
        create={PionerosEnergiaCreate}
        edit={PionerosEnergiaEdit}
        options={{
          label: 'FG Pioneros Energia',
        } as ResourceOptions}
        icon={BoltIcon}
      />

    </Admin>
  );
}

export default App;